import { render, staticRenderFns } from "./recorddashboard.vue?vue&type=template&id=ac15ce2c&scoped=true"
import script from "./recorddashboard.vue?vue&type=script&lang=js"
export * from "./recorddashboard.vue?vue&type=script&lang=js"
import style0 from "./recorddashboard.vue?vue&type=style&index=0&id=ac15ce2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac15ce2c",
  null
  
)

export default component.exports